module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAMAAAAMs7fIAAAASFBMVEUAAABUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGYRfjAxAAAAF3RSTlMA+ZA4MAaRLAvXlOTUmMq7jirYvUQWFW2FQo8AAAB7SURBVBjTZY9ZDsMgDERnIKwhadJt7n/T1iJVJXgfID8Z7IFxHoUsx4mLUHWx5S5uYvQ5+0g9gpmqdenNy6r6vRJpoisyAU7RCsnOKAcU+b/xKgAVrDaAIA4mi9OrNv88Tx833H4pnKVwlNp7SNq09/bk7mRzCa/9iZkP5dgH+5r0B4gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_amplify.png
// module id = nNQK
// module chunks = 9